// handle password reset
$(document).ready(function () {
  $resetBtn = $('.js-reset-password-btn');
  $alert = $('.js-reset-password-message');
  $alertContent = $alert.find('.alert__content');
  $resetBtn.click(function () {
    // disabled button, hide message
    $resetBtn.prop('disabled', true);
    $alert.hide();
    $alert.removeClass('alert--danger').removeClass('alert--success');
    $alertContent.html('');
    // request pwd reset
    apiUserResetPassword().then(function (result) {
      console.log({
        resetResult: result
      });
      // enable button again, show message
      if (result.status === 'success') {
        $alert.addClass('alert--success');
      } else {
        $alert.addClass('alert--danger');
      }
      $alertContent.html(result.message);
      $alert.show();
      $resetBtn.prop('disabled', false);
    });
  });
});